import React from 'react';
import { Navbar, Container, Nav } from 'react-bootstrap';
import { SECTIONS } from '../config/sections';

export const NavBar = () => {
  return (
    <Navbar expand="lg" className="portfolio-nav" sticky="top" style={{ height: 'var(--nav-height, 56px)' }}>
      <Container>
        <Navbar.Brand href="#home">Patrick Lu | Portfolio</Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            {SECTIONS.map(({ id, label }) => (
              <Nav.Link key={id} href={`#${id}`}>{label}</Nav.Link>
            ))}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};